import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./App.css";
import LandingPage from "./LandingPage";

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <LandingPage />
  </StrictMode>
);
